import { render } from "./SearchResultsItemTitle.vue?vue&type=template&id=2ee352fe&scoped=true"
import script from "./SearchResultsItemTitle.vue?vue&type=script&lang=js"
export * from "./SearchResultsItemTitle.vue?vue&type=script&lang=js"

import "./SearchResultsItemTitle.vue?vue&type=style&index=0&id=2ee352fe&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee352fe"]])

export default __exports__